












































































import {
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  reactive,
  readonly,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import SelectAnySpaceTargetFolder from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/index.vue';
import SingleFileUpload from '@/renderer/components/Upload/SingleFileUpload.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import uploadHandler, { UploadFile } from '@/renderer/components/SpacePage/compositions/uploadHandler/index';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import tips from '@/renderer/scripts/utils/tips';
import uploadTaskManager from '@/renderer/scripts/utils/upload/index';
import smh from '@/renderer/scripts/smh';
import { httpUrl } from '@/renderer/scripts/http';
import user from '@/renderer/scripts/utils/user';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { SubTask } from '@/renderer/scripts/utils/TaskManager/types';

export function createDialogHandler() {
  const show = ref(false);
  const methods = {
    open() {
      show.value = true;
    },
    close() {
      show.value = false;
    },
  };
  return {
    show,
    methods,
  };
}
interface FormData {
  file:
    | {
        name: string;
      }
    | UploadFile;
  dirPath: string;
  spaceId: string;
  totalPath: string;
  teamPath: string[];
}
enum StepMap {
  CREATE = 'create',
  PREVIEW = 'preview',
  SAVE = 'save',
}
export default defineComponent({
  components: {
    SingleFileUpload,
    SelectAnySpaceTargetFolder,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    /**
     * description: 合同模板文件信息
     * 上传文件时 item 为 null
     */
    item: {
      type: Object || null,
      default: null,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const step = ref<StepMap>(StepMap.CREATE);
    const loadTemplate = ref(false);
    const rule = readonly({
      message: i18n_t('请上传.pdf、.doc、.docx格式文件，限制 60 MB 以内的文件'),
      accept: '.pdf,.doc,.docx',
      validator(file: File) {
        const filename = file.name;
        const ext = filename.slice(filename.lastIndexOf('.') + 1);
        if (!['pdf', 'doc', 'docx'].includes(ext.toLowerCase())) {
          tips.error(i18n_t('格式不正确，请上传.pdf、.doc、.docx格式文件'));
          return false;
        }
        if (file.size > ConstantConfig.esignFileMaxSize) {
          tips.error(i18n_t('请上传 60 MB 以内的文件'));
          return false;
        }
        return true;
      },
    });
    const headerTitle = computed(() => {
      let title = '';
      switch (step.value) {
        case StepMap.SAVE:
          title = i18n_t('选择保存路径');
          break;
        case StepMap.CREATE:
          title = i18n_t('发起合同');
          break;
        case StepMap.PREVIEW:
          title = i18n_t('合同预览');
          break;
        default:
          break;
      }
      return title;
    });
    const form = reactive<FormData>({
      file: {
        name: '',
      },
      dirPath: '',
      spaceId: '',
      totalPath: '',
      // 空间名/团队面/dirPath
      teamPath: [], // 团队路径
    });

    const spaceId = computed(() => form.spaceId);
    const showSelectFolder = ref(false);
    const disabledConfirmBtn = computed(() => {
      if (step.value === StepMap.CREATE) {
        return !form.file.name;
      }
      if (step.value === StepMap.PREVIEW) {
        return false;
      }
      return !form.totalPath;
    });
    const confirmBtnContent = computed(() => {
      if (step.value === StepMap.PREVIEW) {
        return i18n_t('创建合同');
      }
      return i18n_t('确定');
    });
    const cancelBtnParams = computed(() => {
      if (step.value === StepMap.PREVIEW) {
        return null;
      }
      return {
        content: i18n_t('取消'),
      };
    });
    const { methods: uploadMethods } = uploadHandler();
    const { methods: previewMethods } = openPreviewHandler(spaceId);
    const previewTemplate = computed(() => {
      const { orgId: organizationId } = vm.$store.getters;
      const templateId = props.item?.templateId;
      const { userToken } = user.getUserInfoSync();
      const url = `${httpUrl.SMHUrl}/user/v1/e-sign/${organizationId}/template/${templateId}?preview&user_token=${userToken}`;
      return url;
    });
    const methods = {
      closeDialog() {
        innerShow.value = false;
      },
      resetData() {
        form.file = {
          name: '',
        };
        form.dirPath = '';
        form.spaceId = '';
        form.totalPath = '';
        if (props.item) {
          step.value = StepMap.PREVIEW;
          loadTemplate.value = true;
        } else {
          step.value = StepMap.CREATE;
        }
      },
      onSelectPath(params: { spaceId: string; dirPath: string; totalPath: string; teamPath: string }) {
        form.dirPath = params.dirPath;
        form.spaceId = params.spaceId;
        form.totalPath = params.totalPath;
        form.teamPath = params.teamPath ? params.teamPath.split('/') : [];
        showSelectFolder.value = false;
      },
      onConfirm() {
        if (step.value === 'create' || step.value === 'preview') {
          step.value = StepMap.SAVE;
          if (vm.$store.getters.editionFlag === 'personal') {
            form.totalPath = i18n_t('个人空间');
          }
        } else {
          // 将文件上传并在上传成功后跳转至该文件的预览页面
          tips.loading(i18n_t('正在上传电子签文件'), 0);
          if (props.item) {
            this.uploadTemplateFile();
          } else {
            this.uploadFile();
          }
          this.closeDialog();
        }
      },
      async uploadTemplateFile() {
        const fileName = `${props.item.name}.docx`;
        const filePath = form.dirPath ? `${form.dirPath}/${fileName}` : fileName;
        try {
          const { data } = await smh.commonAPI.getFileByTemplateId({
            filePath,
            spaceId: spaceId.value,
            fromTemplate: props.item.templateId,
          });
          tips.closeAll();
          methods.openPreview({
            path: filePath,
            spaceId: spaceId.value,
          });
        } catch (error) {
          tips.error(error as MsgError);
        }
      },
      async uploadFile() {
        let options;
        if (!form.spaceId) {
          options = {
            teamPathInfo: {
              path: form.teamPath,
              spaceId: form.spaceId,
            },
            routerName: 'teamSpace',
          };
        }
        uploadMethods.filesDeal([form.file as UploadFile], form.dirPath, form.spaceId, options);
      },
      async handlerUploadFileFinished(subTask: SubTask<Uploader.UploadFileInfo>) {
        const { info: uploadFileInfo } = subTask;
        if (form.file.name === uploadFileInfo.name) {
          tips.closeAll();
          const item = {
            path: uploadFileInfo.remotePath,
            spaceId: spaceId.value,
          };
          methods.openPreview(item);
        }
      },
      async openPreview(item: { path: string; spaceId: string }) {
        try {
          const { data: fileDetail } = await smh.commonAPI.getDirectoryInfo({
            dirPath: item.path,
            spaceId: item.spaceId,
          });
          previewMethods.openPreview(fileDetail, 1);
        } catch (error) {
          tips.error(i18n_t('获取文件信息出错，请前往同步路径打开文件进行签名。'));
        }
      },
      onLoadTemplateError() {
        loadTemplate.value = false;
        tips.error(i18n_t('文件加载出错，请检查是否存在该文件'), 5000);
      },
      onLoadTemplateSuccess(e: Event) {
        loadTemplate.value = false;
      },
    };
    watch(innerShow, val => {
      if (val) {
        methods.resetData();
      }
    });
    onMounted(() => {
      uploadTaskManager.on('subtask-finish', methods.handlerUploadFileFinished);
    });
    onUnmounted(() => {
      uploadTaskManager.off('subtask-finish', methods.handlerUploadFileFinished);
    });
    return {
      innerShow,
      rule,
      headerTitle,
      form,
      disabledConfirmBtn,
      showSelectFolder,
      previewTemplate,
      confirmBtnContent,
      cancelBtnParams,
      step,
      loadTemplate,
      ...methods,
    };
  },
});
